"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    generateProductDowngradeLink: ()=>generateProductDowngradeLink,
    getProductDowngradeLink: ()=>getProductDowngradeLink
});
const row_js_namespaceObject = require("../aegis-api-config/row.js");
const ttp_js_namespaceObject = require("../aegis-api-config/ttp.js");
const allConfig = {
    online: {
        area: 'online',
        urlTemplate: row_js_namespaceObject.productBackupLinkTemplate
    },
    sinf: {
        area: 'sinf',
        urlTemplate: row_js_namespaceObject.productBackupLinkTemplate
    },
    sandbox: {
        area: 'sandbox',
        urlTemplate: row_js_namespaceObject.productBackupLinkTemplate
    },
    'ttp-us': {
        area: 'ttp-us',
        urlTemplate: ttp_js_namespaceObject.ttpProductBackupLinkV2Template
    }
};
const config = {
    local: allConfig.sandbox,
    sandbox: allConfig.sandbox,
    boe: allConfig.online,
    online: allConfig.online,
    hl: allConfig.online,
    lq: allConfig.online,
    pd: allConfig.online,
    us: allConfig.online,
    i18n: allConfig.online,
    'ttp-eu': allConfig.online,
    'ttp-eu-de': allConfig.online,
    'ttp-row': allConfig.online,
    'ttp-row-sg': allConfig.online,
    'ttp-us': allConfig['ttp-us'],
    'ttp-us-limited': allConfig['ttp-us'],
    tx: void 0,
    'tx-tt': void 0,
    sinf: allConfig.sinf,
    sinfi18n: allConfig.sinf,
    sinfonlinea: allConfig.sinf,
    'sinf-boe': allConfig.sinf,
    'sinf-xfl': void 0,
    'sinf-xfl-boe': void 0,
    xfl: void 0,
    'i18n-sg': allConfig.online,
    'boe-i18n': allConfig.online,
    volcgroup: void 0,
    'volcgroup-boe': void 0,
    'i18n-bd': allConfig.online,
    'i18n-bd-de': allConfig.online
};
const generateProductDowngradeLink = (param)=>{
    let { domainID, configType } = param;
    if (config[domainID] || !(domainID in config)) {
        const item = config[domainID] || allConfig.online;
        const fileKey = `${item.area}${configType}`;
        return item.urlTemplate.replace('{file_key}', fileKey);
    }
};
const getProductDowngradeLink = (domainID, type)=>generateProductDowngradeLink({
        domainID,
        configType: type
    });
exports.generateProductDowngradeLink = __webpack_exports__.generateProductDowngradeLink;
exports.getProductDowngradeLink = __webpack_exports__.getProductDowngradeLink;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "generateProductDowngradeLink",
    "getProductDowngradeLink"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
